export const userTypeHasPrivilegedClubAccess = (userType) => {
  const permissions = userType?.permissions || {};

  return permissions.clubAdmin?.canView === true
    || permissions.clubAdmin?.canEdit === true
    || permissions.clubConfiguration?.canView === true
    || permissions.clubConfiguration?.canEdit === true;
};

export const userTypeAllowsOnlineSignup = (userType) => (
  userType?.membership?.canSignUpOnline === true
);

export const wouldGrantPrivilegedClubAccess = (category, permission, value) => {
  if (!value) return false;
  if (category !== 'clubAdmin' && category !== 'clubConfiguration') return false;
  return permission === 'canView' || permission === 'canEdit';
};

export const isPrivilegedPermissionBlockedByOnlineSignup = (userType, category) => (
  (category === 'clubAdmin' || category === 'clubConfiguration')
  && userTypeAllowsOnlineSignup(userType)
  && String(userType?.id) !== '0'
  && String(userType?.id) !== '1'
);

export const ONLINE_SIGNUP_BLOCKED_BY_PRIVILEGED_ACCESS_MESSAGE =
  'Online signup cannot be enabled while this user type has Club Admin or Club Config View or Edit access.';

export const PRIVILEGED_ACCESS_BLOCKED_BY_ONLINE_SIGNUP_MESSAGE =
  'Club Admin and Club Config access cannot be enabled while online membership signup is allowed for this user type. Disable online signup in Membership settings first.';

export const hasOnlineSignupPrivilegedAccessConflict = (userType) => (
  userTypeAllowsOnlineSignup(userType) && userTypeHasPrivilegedClubAccess(userType)
);
